
/**
 * Module for filtering a collection of items by matching a live search text field to the item's text contents.
 */

class SearchOnPage {
  /**
   * @param {Object} [options] -
   * @param {String} [options.searchableItems] - A selector for the individual items to be filtered
   * @param {String} [options.searchableContent] - A selector for the elements with searchable text content
   * @param {String} [options.searchInput] - A selector for the search input element
   * @param {String} [options.hiddneClass] - A classname which hides an individual search item
   */
  constructor(options) {
    const defaults = {
      searchableItems: '.listing__item',
      searchableContent: '.item__info-val',
      searchInput: '#freeSearch',
      hiddenClass: 'listing__item--hidden',
    };
    Object.assign(this, defaults, options);
  }

  /**
   * Initialize a SearchOnPage instance
   */
  init() {
    this._searchInput = document.querySelector(this.searchInput);
    if(!this._searchInput) {
      return;
    }
    this._searchInput.addEventListener('input', this.handleSearchInput.bind(this));

    this._searchableItems = Array.from(
      document.querySelectorAll(this.searchableItems)
    ).map(this.initSearchableItem, this);

    // Perform a search if input is already populated
    if(this._searchInput.value !== '') {
      this.search(this._searchInput.value);
    }
  }

  /**
   * Event handler for the search input field
   *
   * @param {Event} event - An event object from an input element
   */
  handleSearchInput(event) {
    const searchTerm = event.target.value.toLowerCase();
    this.search(searchTerm);
  }

  /**
   * Hide/show items based on search results. Displays all items if search term is empty.
   *
   * @param {String} searchTerm - The string to search for
   */
  search(searchTerm) {
    if(searchTerm !== '') {
      this._searchableItems.forEach(item => {
        item.element.classList.toggle(this.hiddenClass, item.content.indexOf(searchTerm) === -1);
      });
    } else {
      // remove modifier class form all items
      this._searchableItems.forEach(item => {
        item.element.classList.remove(this.hiddenClass);
      });
    }
  }

  /**
   * Finds search terms from searchable elements and concatenates them into a single string
   *
   * @param {HTMLElement} element - The element which's descendants to search in
   * @returns {Object} - Object with a searchable content string and a reference to the search item
   */
  initSearchableItem(element) {
    const contentEl = Array.from(
      element.querySelectorAll(this.searchableContent)
    );
    const content = contentEl.reduce((a, b) => `${a} ${b.innerText.toLowerCase()}`, '').trim();
    return { element, content };
  }
}

module.exports = SearchOnPage;
